import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
	noDivider?: boolean;
	disabled?: boolean;
};

export const ProfileListItem: FC<Props> = ({
	label,
	onClick,
	noDivider,
	disabled,
}) => {
	const theme = useTheme();

	return (
		<Stack>
			<Stack
				direction={"row"}
				alignItems={"center"}
				justifyContent={"space-between"}
				height={48}
				onClick={disabled ? undefined : onClick}
				sx={{
					cursor: disabled ? "default" : "pointer",
					opacity: disabled ? 0.5 : 1,
				}}
			>
				<Typography
					variant="deprecatedH3"
					color={theme.palette.deprecated.grey[700]}
				>
					{label}
				</Typography>
				<ChevronRight size={16} color={theme.palette.primary.main} />
			</Stack>
			{!noDivider && (
				<Divider sx={{ borderColor: theme.palette.deprecated.grey[200] }} />
			)}
		</Stack>
	);
};
